import { gql } from "@apollo/client"

// Fragments
const SYTEM_USER_FRAGMENTS = {
  systemUserDetail: gql`
    fragment SystemUserListFrag on BaseUserType {
      id
      firstName
      username
      lastName
      fullName
      isBlocked
      blockRemark
      number
      email
      status
      createdAt
      dateOfBirth
      isStaff
      groups {
        id
        name
      }
      departments {
        id
        name
      }
    }
  `,
}

const SYSTEM_USER_DETAIL_FRAG = gql`
  fragment SystemUserDetailFrag on BaseUserType {
    id
    firstName
    username
    lastName
    fullName
    isBlocked
    blockRemark
    number
    email
    status
    createdAt
    dateOfBirth
    isStaff
    groups {
      id
      name
    }
    education
    customerId
    departments {
      id
      name
    }
    metadata {
      secondaryNumber
      personalEmail
      instituteName
      yearOfPassing
      experience
      previousOrganisation
      interviewDate
      joiningDate
      icardIssuedDate
      visitingCardIssuedDate
      employmentTypeCurrentCompany
      resignationDateCurrentCompany
      laptopIssuedDate
      resignationDate
      attachments
      district
      address
    }
  }
`
// System User Links
const SYSTEM_USER_GROUPS = gql`
  query allGroups {
    allGroups {
      id
      name
      userCount
      permissions {
        id
        name
      }
    }
  }
`
const SEARCH_SYSTEM_USER = gql`
  query systemUserDetails($id: Int!) {
    userDetails(userId: $id) {
      ...SystemUserDetailFrag
    }
  }
  ${SYSTEM_USER_DETAIL_FRAG}
`
const SYSTEM_USER_LIST = gql`
  query allSchedulingOfficers(
    $query: String
    $groupName: String
    $first: Int
    $skip: Int
  ) {
    usersByGroup(
      groupName: $groupName
      query: $query
      first: $first
      skip: $skip
    ) {
      ...SystemUserListFrag
    }
  }
  ${SYTEM_USER_FRAGMENTS.systemUserDetail}
`
const ADD_UPDATE_SYSTEM_USER = gql`
  mutation addUserMutation(
    $id: Int
    $username: String!
    $number: String!
    $groups: [Int]
    $lastName: String!
    $firstName: String!
    $dateOfBirth: Date
    $departments: [Int]
    $email: String
    $metadata: BaseUserMetadataInput
    $education: String
    $customerId: String
  ) {
    addUser(
      user: {
        id: $id
        number: $number
        groups: $groups
        username: $username
        lastName: $lastName
        firstName: $firstName
        dateOfBirth: $dateOfBirth
        departments: $departments
        email: $email
        education: $education
        customerId: $customerId
        metadata: $metadata
      }
    ) {
      user {
        ...SystemUserDetailFrag
      }
    }
  }
  ${SYSTEM_USER_DETAIL_FRAG}
`

const DELETE_USER = gql`
  mutation deleteBaseUser($id: Int!) {
    delBaseUser(userId: $id) {
      user {
        id
        number
        status
      }
    }
  }
`

export const SEND_USER_CREDENTIALS = gql`
  query sendUserCredentials($userId: ID!, $type: String) {
    sendUserCredentials(userId: $userId, mType: $type)
  }
`
export {
  ADD_UPDATE_SYSTEM_USER,
  SYSTEM_USER_LIST,
  SEARCH_SYSTEM_USER,
  SYTEM_USER_FRAGMENTS,
  SYSTEM_USER_GROUPS,
  DELETE_USER,
}
